<template>
  <div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalCambiarcosto"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Cambio de Costo</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="costodata.producto != null">
            <form @submit.prevent="proyectarPrecios">
              <div class="row">
                <div class="col-12">
                  <h5>
                    {{ costodata.producto_obj.sku }} -
                    {{ costodata.producto_obj.nombre }}
                  </h5>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="form-group">
                    <label for>Costo Actual</label>
                    <div>
                      <input
                        id="valido_desde"
                        ref="valido_desde"
                        class="form-control"
                        placeholder="Costo Actual"
                        type="text"
                        v-model="costodata.costo"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <a class="btn btn-success text-light" @click="irAprecios">
                    <i class="fa fa-pencil"></i>
                    Ir a precios de venta
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <button type="submit" class="btn btn-success">
                    Proyectar Precios de Venta
                  </button>
                  <hr />
                </div>
              </div>
            </form>
            <div class="row">
              <div class="col-12">
                <div class="table-responsive">
                  <table
                    class="table table-bordered table-lg table-v2 table-striped"
                  >
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th colspan="2">Anterior</th>
                        <th colspan="2">Nuevo</th>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th>Lista</th>
                        <th>Unidades</th>
                        <th>Tipo</th>
                        <th>Margen</th>
                        <th>Otros Cost.</th>

                        <th>Costo</th>
                        <th>Venta</th>
                        <th>Costo</th>
                        <th>Venta</th>
                        <th>Diferencia</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="precio in precios" :key="precio.id">
                        <td class="nowrap">
                          {{ precio.lista_precio_id }}
                        </td>
                        <td>
                          {{ precio.cantidad_unidades }}
                        </td>
                        <td class="text-right">{{ precio.tipo_calculo }}</td>
                        <td class="text-right">{{ precio.margen }}</td>
                        <td class="text-right">Q {{ precio.otros_costos }}</td>
                        <td class="text-right">Q {{ precio.costo }}</td>
                        <td class="text-right">Q {{ precio.precio }}</td>
                        <td class="text-right">Q {{ precio.costo_nuevo }}</td>
                        <td class="text-right">
                          <span
                            v-if="precio.precio_nuevo > precio.precio"
                            class="text-success"
                            >Q {{ precio.precio_nuevo }}</span
                          >
                          <span
                            v-if="precio.precio_nuevo <= precio.precio"
                            class="text-danger"
                            >Q {{ precio.precio_nuevo }}</span
                          >
                        </td>
                        <td class="text-right">
                          <span
                            v-if="precio.precio_nuevo > precio.precio"
                            class="text-success"
                            >+ {{ precio.diferencia }}</span
                          >
                          <span
                            v-if="precio.precio_nuevo <= precio.precio"
                            class="text-danger"
                            >{{ precio.diferencia }}</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" type="button" @click="cambiarCosto">
              Cambiar Costo
            </button>
            <button
              class="btn btn-primary"
              type="button"
              @click="cambiarCostoYPrecios"
            >
              Cambiar Costo y Cambiar Precios
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  data() {
    return {
      errors: {},
      precios: [],
    };
  },
  props: {
    costodata: {
      type: Object,
      required: true,
      default: {
        id: null,
        producto: null,
        producto_obj: {},
      },
    },
  },
  watch: {},
  computed: {},
  mounted() {
    let self = this;
    $("#modalCambiarcosto").on("hidden.bs.modal", function (e) {
      self.precios = [];
    });
  },
  methods: {
    irAprecios() {
      this.$router.push({
        name: "cat-productos-precios",
        params: { sku: this.costodata.producto_obj.sku },
      });
      $("#modalCambiarcosto").modal("hide");
    },
    proyectarPrecios() {
      let self = this;
      DynamicService.getAction(
        "cat",
        "productos",
        self.costodata.producto,
        "proyeccion_precios_cambio_costo",
        {
          nuevo_costo: self.costodata.costo,
        }
      )
        .then((res) => {
          self.precios = res.data;
          console.log(res.data);
          self.errors = "";
        })
        .catch((error) => {
          self.errors = error.response.data;
          Notifications.alert.error(
            "Proyectar Precios",
            error.response.data.detail
          );
        });
    },
    cambiarCosto() {
      let self = this;
      let params = self.costodata;
      delete params.otros_costos;
      delete params.id;
      params.actualizar_precios = false;
      DynamicService.save("cat", "producto-costo", params)
        .then((res) => {
          Notifications.alert.success(
            "Cambiar Precio de Costo",
            "Realizado satisfactoriamente"
          );
        })
        .catch((err) => {
          Notifications.alert.error(
            "Cambiar Precio de Costo",
            err.response.data.costo[0]
          );
        });
    },
    cambiarCostoYPrecios() {
      let self = this;
      let params = self.costodata;
      delete params.otros_costos;
      delete params.id;
      params.actualizar_precios = true;
      DynamicService.save("cat", "producto-costo", params)
        .then((res) => {
          Notifications.alert.success(
            "Cambiar Precio de Costo",
            "Realizado satisfactoriamente"
          );
          console.log(res.data);
          self.proyectarPrecios();
        })
        .catch((err) => {
          Notifications.alert.error(
            "Cambiar Precio de Costo",
            err.response.data.costo[0]
          );
        });
    },
  },
};
</script>
